import { render, staticRenderFns } from "./ShopByGuideButton.vue?vue&type=template&id=747002f8&scoped=true&"
import script from "./ShopByGuideButton.vue?vue&type=script&lang=ts&"
export * from "./ShopByGuideButton.vue?vue&type=script&lang=ts&"
import style0 from "./ShopByGuideButton.vue?vue&type=style&index=0&id=747002f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "747002f8",
  null
  
)

export default component.exports